import { PersonalizeProductComponent } from './../modals/personalize-product/personalize-product.component';
import { Router } from "@angular/router";
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  OnDestroy
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { combineLatest, Subscription } from "rxjs";
import { UpdateProductComponent } from "@app/modules/modals/update-product/update-product.component";
import { OrdersService } from '@app/services/order/orders.service';
import { PdvService } from '@app/services/pdv/pdv.service';
@Component({
  selector: "app-panier",
  templateUrl: "./panier.component.html",
  styleUrls: ["./panier.component.scss"]
})
export class PanierComponent implements OnInit, OnDestroy {
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true
  };
  orderTypes: any[] = [];
  chosenOrderType: number;
  orderType: number;
  orderTypLabel: String = "";
  @ViewChild("template")
  template;
  @Input()
  updatePanier = true;
  @Input()
  showButton: boolean;
  @Input()
  btnValidate: boolean = true;
  @Output()
  update = new EventEmitter<number>();
  @Output()
  setOrderType = new EventEmitter<number>();
  @Output()
  closePanier = new EventEmitter<any>();
  subscriptions: Subscription[] = [];
  subscriptions2: Subscription[] = [];
  order: any = {};
  elementsNbr: number;
  amountMiniDelivery: number;
  bounceIn: boolean = false;
  discount: number = 0;
  discountFrom: number = 0;
  constructor(
    private modalService: BsModalService,
    private changeDetection: ChangeDetectorRef,
    private orderService: OrdersService,
    private pdvService: PdvService,
    private router: Router
  ) {
    const sub4 = this.orderService.order.subscribe(order => {
      this.order = order;
      console.log(order)
      this.elementsNbr = order.elementsNbr;
    });
    const sub5 = this.orderService.amountMiniDelivery.subscribe(amountMiniDelivery => {
      this.amountMiniDelivery = amountMiniDelivery;
    });
    const subs1 = this.pdvService.orderTypes.subscribe((orderTypes: any[]) => {
      this.orderTypes = orderTypes;
      if (this.chosenOrderType > 0) {
        this.orderTypLabel = this.orderTypes.filter(
          o => o.id === this.chosenOrderType
        )[0].label;
      }
    });
    const subs2 = this.orderService.chosenOrderType.subscribe(
      (chosenOrderType: number) => {
        this.chosenOrderType = chosenOrderType;
        if (this.orderTypes.length > 0 && chosenOrderType > 0) {
          this.orderTypLabel = this.orderTypes.filter(
            o => o.id === this.chosenOrderType
          )[0].label;
        }
      }
    );
    const subs6 = this.pdvService.pdv.subscribe(
      (data: any) => {
        this.discount = data.discount;
        this.discountFrom = data.discountFrom;
      }
    )
    this.subscriptions2
    this.subscriptions2.push(subs1, subs2, sub4, sub5, subs6);
  }

  ngOnInit() {
    this.bounceIn = true;
    setTimeout(() => {
      this.bounceIn = false;
    }, 500)
  }


  incrQty(i, j) {
    this.orderService.incrQty(i, j);
  }

  decrQty(i, j) {
    this.orderService.decrQty(i, j);
  }

  removeElement(i, j) {
    this.orderService.removeElement(i, j);
  }

  clear() {
    this.orderService.clearOrder();
  }

  updateElement(i) {
    if (this.updatePanier) {
      const _combine = combineLatest(
        this.modalService.onHidden
      ).subscribe(() => this.changeDetection.markForCheck());
      this.subscriptions.push(
        this.modalService.onHidden.subscribe((element: any) => {
          if (element) {
            const totalement = Number(this.order.elements[i].total);
            const qtyelement = Number(this.order.elements[i].qty);
            this.elementsNbr -= qtyelement;
            this.order.amount -= totalement;
            element.total *= Number(element.qty);
            this.order.elements[i] = element;
            this.elementsNbr += element.qty;
            this.order.elementsNbr = this.elementsNbr;
            this.order.amount += Number(element.total);
          }
          this.unsubscribe();
        })
      );
      this.subscriptions.push(_combine);
      this.bsModalRef = this.modalService.show(PersonalizeProductComponent, {
        class: "modal-content3"
      });
      this.bsModalRef.content.product2 = JSON.parse(
        JSON.stringify(this.order.elements[i])
      );
    }
  }


  changeMode() {
    if (this.elementsNbr > 0) {
      this.modalRef = this.modalService.show(this.template, {
        class: "modal-sm"
      });
    } else {
      //this.setOrderTypeEvent();
    }
  }

  // setOrderTypeEvent() {
  //   this.router.navigate(['/modes']);
  // }

  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  unsubscribe2() {
    this.subscriptions2.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions2 = [];
  }

  confirm() {
    this.modalRef.hide();
    this.orderService.clearOrder();
    this.closePanier.emit(true);
    setTimeout(() => {
      // this.setOrderTypeEvent();
    }, 1000)
  }

  decline() {
    this.modalRef.hide();
  }

  ngOnDestroy() {
    this.unsubscribe2();
  }
}
